/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.docking.js

import com.macrofocus.common.properties.SimpleProperty
import js.objects.unsafeJso
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.*

/**
 * Area of the docking panel showing the active dockable of a docking bar. Like the Swing `DockingContainer`, it is
 * hidden until a dockable gets activated.
 */
class DockingContainer constructor() : CPComponent {
    private val component = SimpleProperty.newInstance<CPComponent?>(null)
    internal val visibleProperty = SimpleProperty.newInstance<Boolean>(false)

    var center by component
    var visible by visibleProperty

    override val nativeComponent = FC<Props> { props ->
        val (component, _) = useProperty(component)
        val (visible, _) = useProperty(visibleProperty)

        div {
            className = ClassName("DockingContainer")

            style = unsafeJso {
                position = Position.relative
                overflow = Overflow.hidden
                boxSizing = BoxSizing.borderBox
                display = Display.block
                pointerEvents = Auto.auto
                width = 100.pct
                height = 100.pct
            }

            if (component != null && visible) {
                component.nativeComponent()
            }
        }
    }

    fun remove(c: CPComponent?) {
        if (component.value == c) {
            component.value = null
        } else {
            println("DockingContainer: could not find component $c")
        }
    }
}
